<template>
  <v-app id="mainApp" ref="appContainer" v-bind:class="{'lx-dark-app': isInDarkModeOnStart}"
         v-bind:style="{'background-color': compColor.appBackground}">

    <!-- ** impressum + datenschutz link beim login, eigene komponente aus lx_imprint_and_cookie ** -->
    <header v-if="!isLoggedIn" color="transparent" style="z-index:9999;"
            class="py-1 px-2 layout-row layout-align-center-center" dark app clipped-left :height="48" padless>
      <v-spacer></v-spacer>
      <v-btn text v-show="!imprintDialogVisibility" @click="imprintDialogVisibility = true" dark>
        <span class="amber--text text--darken-3 caption mr-3 text-none">Impressum + Datenschutz</span>
      </v-btn>
    </header>

    <!-- impressums popup, eigene komponente lx_imprint_and_cookie -->
    <!-- während lx-imprint-dialog sich in lxvue befindet, wird der Inhaltstext in jeder Anwendung selber gepflegt und per slot übergeben-->
    <lx-imprint-dialog>
      <imprint-content></imprint-content>
    </lx-imprint-dialog>

    <!-- ** top app-bar ** -->

    <notifications group="custom-template" position="bottom right" width="550">
      <template v-slot:body="props">

        <div class="green white--text elevation-9 layout-row mb-5 mr-5" style="border-radius: 5px;"
             v-if="props.item.type !== 'error' && props.item.type !== 'warning'">
          <div class="pa-4 layout-column layout-align-center-center">
            <v-icon>done</v-icon>
          </div>
          <div class="layout-column flex py-2">
            <div>
              <div class="body-2 font-weight-bold">{{ props.item.title }}</div>
            </div>
            <div class="flex layout-row body-2 layout-align-start-center">
              <div v-html="props.item.text">
              </div>
            </div>
          </div>
          <div class="layout-column layout-align-center-center pa-4">
            <a class="close green--text text--lighten-3" @click="props.close">ok</a>
          </div>
        </div>

        <div class="orange white--text elevation-9 layout-row mb-5 mr-5" style="border-radius: 5px;"
             v-else-if="props.item.type !== 'error' && props.item.type === 'warning'">
          <div class="pa-4 layout-column layout-align-center-center">
            <v-icon>info</v-icon>
          </div>
          <div class="layout-column flex py-2">
            <div>
              <div class="body-2 font-weight-bold">{{ props.item.title }}</div>
            </div>
            <div class="flex layout-row body-2 layout-align-start-center">
              <div v-html="props.item.text">
              </div>
            </div>
          </div>
          <div class="layout-column layout-align-center-center pa-4">
            <a class="close orange--text text--darken-3" @click="props.close">ok</a>
          </div>
        </div>

        <div class="red white--text elevation-9 layout-row mb-5 mr-5" style="border-radius: 5px;" v-else>
          <div class="pa-4 layout-column layout-align-center-center">
            <v-icon>error</v-icon>
          </div>
          <div class="layout-column flex py-2">
            <div>
              <div class="body-2 font-weight-bold">{{ props.item.title }}</div>
            </div>
            <div class="flex layout-row body-2 layout-align-start-center">
              <div v-html="props.item.text">
              </div>
            </div>
          </div>
          <div class="layout-column layout-align-center-center pa-4">
            <a class="close red--text text--lighten-3" @click="props.close">ok</a>
          </div>
        </div>
      </template>
    </notifications>


    <!-- ** Content Bereich ** -->
    <v-main ref="vmain">
      <div style="width:100%;height:100%;" class=""
           :class="{'layout-column': isLayoutHorizontal, 'layout-row': !isLayoutHorizontal}">

        <lx-btn-bar v-model="isLayoutHorizontal" v-if="isLayoutMinimal &&  isLoggedIn"></lx-btn-bar>
        <div class="flex layout-row">
          <div class="flex layout-column">

            <lx-tab-navigation v-if="isLoggedIn" hideSlider></lx-tab-navigation>

            <div class="flex" style="position:relative;">
              <!--   keep-alive ist wichtig damit inhalt der gerouteten komponenten erhalten bleibt-->

              <transition name="slide-left" mode="out-in">
                <keep-alive v-if="isLoggedIn">
                  <router-view :key="$route.path"/>
                </keep-alive>
                <router-view :key="$route.path" v-else/>
                <!--  :key ist wichtig damit unterschiedliche routen auf die gleiche komponenten trotzdem gerouted  werden-->
              </transition>
            </div>
          </div>
        </div>
      </div>
    </v-main>

    <!-- ** Themeauswahl - Drawer auf der rechten Seite Komponente in lx_theme  ** -->
    <lx-theme-sidebar :allowed-layouts="[1,2]" :allowed-lightings="[1,2]"></lx-theme-sidebar>

    <!-- ** Cookie Nachfrage beim Login, aus Komponente lx_imprint_and_cookie ** -->
    <lx-cookie-question></lx-cookie-question>

    <!-- ** Footer **-->
    <v-footer v-if="isLoggedIn" dark app clipped-left elevation="20"
              :style="{'background-color': 'rgba(255,255,255,0.1)'}"
              :height="20" padless
              class="layout-row pa-0">
      <div class="flex"></div>
      <div class="layout-row layout-align-center-center px-3 caption">
        <strong>Litix</strong>soft<sup>&copy;</sup> <span class="ml-1">{{ new Date().getFullYear() }}</span>
      </div>
      <v-divider vertical></v-divider>
      <div class="layout-row layout-align-center-center px-3 caption" style="cursor:pointer;"
           @click="disableOrEnableLxContext(!isLxContextDisabled)">
        <strong>TumorScout</strong><span class="ml-2"> v.{{ getAppVersionNumber }}</span>
        <div v-if="isLxContextDisabled" style="width:10px;height:10px;border-radius: 50%;" class="ml-2 green"></div>
      </div>
      <v-divider vertical></v-divider>
      <div class="layout-column layout-align-center-center px-4">
        <div class="caption" @click="imprintDialogVisibility = true" style="cursor:pointer;">
          <strong>Impressum</strong>
        </div>
      </div>
    </v-footer>

    <!-- ** öffnet Popup um sich erneut zu authentifizieren ** -->
    <auth-relogin></auth-relogin>

    <lx-context-menu :menu-items="items"></lx-context-menu>

    <first-login-dialog :isDisclaimer="true"
                        :showDialogFirstLogin="showDialogFirstLogin"
                        @close="setInfoForFirstLoginRead"
    ></first-login-dialog>
  </v-app>
</template>

<script>
import Vue from 'vue'
import LxBtnBar from './components/lx_button_bar/LxBtnBar'
import imprintContent from './components/imprint_content/imprintContent'
import firstLoginDialog from './plugins/lx_auth/components/FirstLoginDialog'
import lodash from 'lodash'
import {deviceDetect, isMobile} from 'mobile-device-detect'

const themeConfig = {
  color: 'light-blue',
  mode: 'medium',
  autoMode: false,
  zoomValue: 100,
  layoutVertical: false,
  layoutMinimalistic: false,
  minimal: true,
  horizontal: false
}

const dashboardConfig = [
  {
    moved: false,
    type: "news",
    w: 3,
    x: 3,
    y: 0,
    h: 16,
    i: "1"
  },
  {
    y: 0,
    h: 16,
    i: "0",
    moved: false,
    type: "activity",
    w: 3,
    x: 0
  },
  {
    moved: false,
    type: "downloads",
    w: 3,
    x: 6,
    y: 0,
    h: 10,
    i: "2"
  },
  {
    moved: false,
    type: "feedback",
    w: 3,
    x: 6,
    y: 0,
    h: 6,
    i: "4"
  }
]

const dashboardConfigCompany = [
  {
    moved: false,
    type: "news",
    w: 4,
    x: 0,
    y: 0,
    h: 16,
    i: "1"
  },
  {
    moved: false,
    type: "downloads",
    w: 5,
    x: 4,
    y: 0,
    h: 16,
    i: "2"
  }
]


export default {
  name: 'App',
  data: () => ({
    showMenuInTabs: false,
    items: null,
    isInDarkModeOnStart: false,
    showDialogFirstLogin: false,
    isMobileDevice: isMobile,
    deviceDetectComplete: deviceDetect()
  }),
  components: {
    LxBtnBar,
    imprintContent,
    firstLoginDialog
  },
  mounted () {
    this.setBackgroundBluriness(20)
    this.setBackgroundTransparency(15)

    // wenn irgendwo in der anwendung ein eigenes context menu auf dem
    // Rechtsklick liegt, kann dieses geschlossen werden, wenn man irgendwo hinklickt
    let main = document.getElementById('mainApp')
    main.addEventListener('click', (event) => {
      this.$lxContext.close(event)
    })

    main.addEventListener('contextmenu', (event) => {
      if (!this.isLxContextDisabled) {
        event.preventDefault()
      }
    })

    // load settings and update tabs when browser tab become visible
    document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
          this.$http.get('/users/settings')
            .then(res => {
              if (res.data?.tabs?.tabs) {
                const localTabs = this.getTabsFromStore || []
                const localActiveTabIndex = this.getActiveTabsFromStore || 0
                const foreignTabs = res.data.tabs.tabs || []
                const foreignActiveTabIndex = res.data.tabs.activeTab || 0

                // overwrite all tabs
                this.setAllTabs(foreignTabs)

                if (localTabs.length > 0 && localActiveTabIndex > 0 && localTabs[localActiveTabIndex] && localTabs[localActiveTabIndex].routeParams?.tabid &&
                  foreignTabs.length > 0 && foreignActiveTabIndex > 0 && foreignTabs[foreignActiveTabIndex] && foreignTabs[foreignActiveTabIndex].routeParams?.tabid) {

                  // force set active tab when foreign tab id not local exists
                  const foundIndex = foreignTabs.findIndex(tab => {
                    return tab.routeParams?.tabid === localTabs[localActiveTabIndex].routeParams?.tabid
                  })

                  if (foundIndex === -1) {
                    // set active tab to 0 and foreignActiveTabIndex as active tab to force trigger reload
                    this.setActiveTab(0)

                    this.$nextTick(() => {
                      // set foreignActiveTabIndex to prevent show invalid tab (e.g. tab is delete in other browser tab)
                      this.setActiveTab(foreignActiveTabIndex)
                    })
                  }
                  // else {
                  //   // set active tab to 0 and localActiveTabIndex as active tab to force trigger reload
                  //   // this.setActiveTab(0)
                  //
                  //   this.$nextTick(() => {
                  //     this.setActiveTab(localActiveTabIndex)
                  //   })
                  // }
                }
              }
            })
            .catch(() => {})
        }
    })
  },
  created () {
    this.$nextTick(() => {
      this.setRouterViewInstance(this.$refs.vmain)
    })
    /** wird bei einem refresh der seite ausgeführt strg + r oder refresh button **/
    if (this.isLoggedIn) {
      let userWithoutDashboard = this.getUser()
      delete userWithoutDashboard.settings.dashboard

      Vue.fillLxvueModuleStoresWithUserValues(userWithoutDashboard, themeConfig, this.userIsPhysicianOrEmployee ? dashboardConfig : dashboardConfigCompany)
    }
  },
  methods: {
    /**
     * Delete flag on user to show info for 2fa
     *
     * @param routeToAccount
     */
    setInfoForFirstLoginRead (routeToAccount) {
      // delete flag on user
      this.$http.patch('/account/user/firstLogin')
        .then(() => {
          this.authStore.dispatch('updateWaitForFirstLogin')
        })
        .catch(this.NotifyError)

      // route to account if wished
      if (routeToAccount) {
        this.authStore.dispatch('updateShow2faAfterLogin', true)
        this.addTabToStore({ routeName: 'AccountDetails', options: { headline: 'Account', icon: 'mdi-account-circle' } })
      }

      // close modal of info
      this.$nextTick(() => {
        this.showDialogFirstLogin = false
      })
    },

    openAccount () {
      this.addTabToStore({ routeName: 'AccountDetails', options: { headline: 'Account', icon: 'mdi-account-circle' } })
    },
    enterFullscreen () {
      const doc = window.document
      const docEl = doc.documentElement

      const requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen
      const cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen

      if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
        requestFullScreen.call(docEl)
      } else {
        cancelFullScreen.call(doc)
      }
    }
  },
  watch: {
    isDarkMode (value) {
      this.$nextTick(() => {
        this.isInDarkModeOnStart = value
      })
    },
    isLoggedIn: {
      handler: function (isLoggedIn) {
        if (!isLoggedIn) {
          Vue.checkCoockieStore()
        } else {
          /** browserinfo **/
          let browserMetadata = lodash.cloneDeep(this.deviceDetectComplete)
          browserMetadata.resolution = {
            width: window.innerWidth,
            height: window.innerHeight
          }

          browserMetadata.screen = {
            availWidth: window.screen.availWidth,
            availHeight: window.screen.availHeight,
            width: window.screen.width,
            height: window.screen.height,
            pixelDepth: window.screen.pixelDepth,
            colorDepth: window.screen.colorDepth
          }

          browserMetadata.isEdge = (this.deviceDetectComplete && this.deviceDetectComplete.userAgent && this.deviceDetectComplete.userAgent.indexOf('Edg') >= 0)

          this.$http.post('/account/user/metadata', browserMetadata)
            .then(() => { })
            .catch(() => { })

          let userWithoutDashboard = this.getUser()
          delete userWithoutDashboard.settings.dashboard

          Vue.fillLxvueModuleStoresWithUserValues(userWithoutDashboard, themeConfig, this.userIsPhysicianOrEmployee ? dashboardConfig : dashboardConfigCompany)
        }
      },
      immediate: true,
      deep: true
    },
    'authStore.getters.getAuthUserData' (newValue) {
      if (newValue && newValue.user && newValue.user.waitForFirstLogin) {
        this.showDialogFirstLogin = true
      }
    }
  },
  computed: {
    isLoggedIn () {
      return this.authStore.getters.isLoggedIn
    },
    showLoginPopup () {
      return this.authStore.getters.showLoginPopup
    },
    authUserName () {
      return this.authStore.getters.getAuthUserName
    },
    authUserTitle () {
      return this.authStore.getters.getAuthUserTitle
    },
    getLocationName () {
      return this.getUser().location_name
    },
    userIsPhysicianOrEmployee () {
      return this.authStore.getters.userIsPhysicianOrEmployee
    }
  }
}
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.1s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.05s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.25, 0, 0.5, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}

.zoom-enter-active,
.zoom-leave-active {
  animation-duration: 0.25s;
  animation-fill-mode: both;
  animation-name: zoom;
}

.zoom-leave-active {
  animation-direction: reverse;
}

@keyframes zoom {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  100% {
    opacity: 1;
  }
}
</style>
